export default {
    "FEMALE": "female",
    "MALE": "male"
};